export const initialValuesContractTerms = {
  term_short: "",
  term_description: "",
};
